import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { NacoService } from '../domains/services/naco.service';
import { first, map } from 'rxjs/internal/operators';
import { User } from '../domains/models/user';
import { Observable } from 'rxjs';
import { Storage } from '@ubud/storage';
import { ActivatedRouteSnapshot } from '@angular/router/src/router_state';

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanActivateChild {
    public constructor(private naco: NacoService, private storage: Storage) {
    }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.naco.getUser().pipe(
            first(),
            map((user: User | null) => {
                if (null === user) {
                    const uri = this.naco.buildNestedUri(route.root);
                    const next = this.naco.getCurrentOrigin('/' + this.ltrim(uri));

                    this.storage.set('naco_intended_url', next).then(() => {
                        window.location.href = this.naco.login(
                            'basic email',
                            this.naco.getCurrentOrigin('/auth'),
                        );
                    });
                }

                return !!user;
            }),
        );
    }

    public canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.canActivate(route);
    }

    private ltrim(text: string): string {
        return text.replace(/^\/+/,'');
    }

    private rtrim(text: string): string {
        return text.replace(/\/+$/,'');
    }
}
